/**
 * Динамик тохиргоог серверээс ТАТАЖ, кэшлэх давхарга (`pf002806`).
 *
 * ⚠ Үнэлгээний логик нь `configRules.js`-д — энэ файл зөвхөн IO.
 * ⚠ `version`-оо серверт илгээдэг тул өөрчлөгдөөгүй бол дата дамжихгүй.
 */

import { ApiService } from "../service/ApiService";
import { setConfigRules, getConfigCache } from "./configRules";

const BUNDLE_PC = "pf002806";
const STORAGE_KEY = "ME_CONFIG_RULES";

/** Зэрэг дуудлагыг нэгтгэх promise (олон талбар зэрэг асуувал 1 л хүсэлт). */
let inflight = null;

const readStorage = () => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && Array.isArray(parsed.rules) ? parsed : null;
    } catch (e) {
        return null;
    }
};

const writeStorage = (payload) => {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
        // sessionStorage дүүрсэн / хориглосон — санах ойн кэш хэвээр ажиллана.
    }
};

/**
 * Bundle татах цорын ганц цэг.
 *
 * ⚠ Алдаа гарвал ШИДЭХГҮЙ: хуучин кэшээр үргэлжилнэ, байхгүй бол дүрэмгүй
 *   ажиллана (урсгал бүхэлдээ зогсохоос сэргийлнэ).
 */
const fetchBundle = (version) => {
    if (inflight) return inflight;

    inflight = (async () => {
        try {
            const res = await ApiService(BUNDLE_PC, { version });
            if (res?.unchanged && getConfigCache()) {
                return getConfigCache();
            }
            if (res && Array.isArray(res.rules)) {
                const next = setConfigRules(res);
                writeStorage(next);
            }
            return getConfigCache();
        } catch (e) {
            console.warn("[configRules] татаж чадсангүй — хуучин кэшээр үргэлжилнэ", e);
            return getConfigCache();
        } finally {
            inflight = null;
        }
    })();

    return inflight;
};

/**
 * sessionStorage-оос санах ойн кэшийг СИНХРОНООР сэргээнэ.
 *
 * ⚠ Модуль ачаалах үед НЭГ удаа дуудагдана (доор). JSON Logic-ийн
 * configParam / configMax г.м. нь синхрон тул анхны render-ээс ӨМНӨ кэш
 * бэлэн байх ёстой — эс бөгөөс эхний удаад `null` гарна.
 */
export const restoreConfigRulesFromStorage = () => {
    if (getConfigCache()) return getConfigCache();
    const stored = readStorage();
    return stored ? setConfigRules(stored) : null;
};

/** Кэш байвал серверт очихгүй. Эхний удаад sessionStorage-оос сэргээнэ. */
export const loadConfigRules = async ({ force = false } = {}) => {
    if (!force) restoreConfigRulesFromStorage();
    if (getConfigCache() && !force) return getConfigCache();

    return fetchBundle(force ? null : getConfigCache()?.version ?? null);
};

/**
 * Хувилбар өөрчлөгдсөн эсэхийг ҮРГЭЛЖ шалгана (хямд). Урсгал нээх үед
 * дуудвал админ тохиргоо зассаныг дахин нэвтрэхгүйгээр авна.
 */
export const refreshConfigRules = async () => fetchBundle(getConfigCache()?.version ?? null);

/** Гарах / байгууллага солих үед. */
export const clearConfigRules = () => {
    setConfigRules(null);
    inflight = null;
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        // алгасна
    }
};

// ⚠ Модуль ачаалах үед кэшийг шууд сэргээнэ — хуудас refresh хийхэд
// сүлжээ хүлээхгүйгээр дүрмүүд бэлэн болно.
restoreConfigRulesFromStorage();

export default {
    loadConfigRules,
    refreshConfigRules,
    clearConfigRules,
    restoreConfigRulesFromStorage,
};
